import { Injectable } from '@angular/core';
// Whether the current platform supports the V8 Break Iterator. The V8 check
// is necessary to detect all Blink based browsers.
var /** @type {?} */ hasV8BreakIterator = typeof (window) !== 'undefined' ?
    (window.Intl && ((window.Intl)).v8BreakIterator) :
    (typeof (Intl) !== 'undefined' && ((Intl)).v8BreakIterator);
/**
 * Service to detect the current platform by comparing the userAgent strings and
checking browser-specific global properties.
\@docs-private
 */
var Platform = (function () {
    function Platform() {
        /**
         * Layout Engines
         */
        this.EDGE = /(edge)/i.test(navigator.userAgent);
        this.TRIDENT = /(msie|trident)/i.test(navigator.userAgent);
        this.BLINK = !!(window.chrome || hasV8BreakIterator) && !!CSS && !this.EDGE && !this.TRIDENT;
        this.WEBKIT = /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
        /**
         * Browsers and Platform Types
         */
        this.IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        this.FIREFOX = /(firefox|minefield)/i.test(navigator.userAgent);
        this.ANDROID = /android/i.test(navigator.userAgent) && !this.TRIDENT;
    }
    return Platform;
}());
export { Platform };
Platform.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Platform.ctorParameters = function () { return []; };
function Platform_tsickle_Closure_declarations() {
    /** @type {?} */
    Platform.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    Platform.ctorParameters;
    /**
     * Layout Engines
     * @type {?}
     */
    Platform.prototype.EDGE;
    /** @type {?} */
    Platform.prototype.TRIDENT;
    /** @type {?} */
    Platform.prototype.BLINK;
    /** @type {?} */
    Platform.prototype.WEBKIT;
    /**
     * Browsers and Platform Types
     * @type {?}
     */
    Platform.prototype.IOS;
    /** @type {?} */
    Platform.prototype.FIREFOX;
    /** @type {?} */
    Platform.prototype.ANDROID;
}



//////////////////
// WEBPACK FOOTER
// ./src/app/alyle-ui-profile/core/platform/platform.js
// module id = 1358
// module chunks = 31